// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QJ-z","twoColumnImage":"RJ-z"};